import React from "react";
import Marquee from "react-fast-marquee";

// One slow editorial marquee — Awwwards ribbon.
export default function EditorialMarquee({ items }) {
  const list = items || [
    "Seamless Gutters",
    "Spokane Washington",
    "Ice Dam Ready",
    "Family Owned",
    "Roofing Contractors",
    "Pine Needle Proof",
    "Since 2014",
  ];
  return (
    <section
      data-testid="editorial-marquee"
      className="relative py-8 md:py-12 border-y border-white/10 bg-ink-950 overflow-hidden"
    >
      <Marquee speed={30} gradient={false} pauseOnHover={false}>
        {list.concat(list).map((s, i) => (
          <span
            key={i}
            className="font-display text-[12vw] md:text-[8vw] leading-none tracking-tightest px-8 text-bone-50/90"
          >
            {s}
            <span className="inline-block mx-6 text-copper-500 align-middle">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
